import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConnectionHistoryRecord } from 'src/app/dashboard/services/connected-users.service';

@Component({
  selector: 'app-connection-detail-dialog',
  templateUrl: './connection-detail-dialog.component.html',
  styleUrls: ['./connection-detail-dialog.component.sass']
})
export class ConnectionDetailDialogComponent {
  record: ConnectionHistoryRecord;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConnectionHistoryRecord,
    private dialogRef: MatDialogRef<ConnectionDetailDialogComponent>,
  ) {
    this.record = data;
  }

  close(): void {
    this.dialogRef.close();
  }

  getUserTypeBadge(): { label: string; color: string } {
    if (this.record.isOperator) return { label: 'Operador', color: '#7c3aed' };
    if (this.record.tipoId === 'VE') return { label: 'Venezuela', color: '#0369a1' };
    return { label: 'Chile', color: '#b45309' };
  }

  getDeviceIcon(deviceType: string): string {
    if (deviceType === 'mobile') return 'phone_android';
    if (deviceType === 'tablet') return 'tablet';
    return 'computer';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const parts = dateString.split('T')[0].split('-');
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  formatTime(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('es-VE', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(date);
  }
}
